<template>
  <div class="oembed-video" v-if="show">        
      <div class="video-wrapper-video" v-if="!iframe" v-html="html"></div>   
      <div class="video-wrapper-iframe" v-if="iframe"  v-html="html"></div>   
  </div>
</template>

<script>
export default {
  name: "oembed_video",
  props: {
    content: Object
  },
  data: () => ({
    show: false, 
    iframe: true,   
    html: ''    
  }),
  methods: {
    get_extension( s ) {
      return s.split(/[#?]/)[0].split('.').pop().trim();
    }
  },
  created() {
    // console.log('mounted');
    // console.log(this.iframe);
    // console.log(this.html);
    // console.log(this.content.video);
    if (this.content.video.charAt(0) === '['){            
      var regex = /(?:(?:https?|ftp):\/\/)?[\w/\-?=%.]+\.[\w/\-&?=%.]+/
      var url = this.content.video.match(regex)[0];
      // console.log(url);
      var ext = this.get_extension(url);
      // console.log(ext);
      this.html = '<video width="1920" height="1080" controls>';
      this.html = this.html.concat('<source src="' + url + '" type="video/' + ext + '">');
      this.html = this.html.concat('Your browser does not support the video');
      this.html = this.html.concat('</video>');     
      this.iframe = false;
    }
    else {
      this.html = this.content.video;
    }
    this.show=true;
  } 
  
};
</script>

<style lang="scss">
.oembed-video {  
  position: relative; 
  z-index: 2; 
  .video-wrapper-iframe {
      // padding: 0;
      // margin:0;
      // width: 100%;    
      // height: auto;  
      position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
      iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      } 
  }
  .video-wrapper-video {
    // position: relative;
    // padding-bottom: 56.25%; /* 16:9 */
    // height: 0;
    padding: 0;
      margin:0;
      width: 100%;    
      height: auto;  
      video{
        display: block;
        width: 100%    !important;
        height: auto   !important;
      }
  }
}
</style>